import styled, { css } from 'styled-components';

import IconCaution from 'components/icons/caution';
import IconCircleCheck from 'components/icons/circle-check';
import IconClose from 'components/icons/close';

import { ToastType } from './types';

/**
 * ToastView
 */
export const Wrapper = styled.div<{ type: ToastType }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-height: 800px;
  min-height: 64px;

  ${({ type }) => {
    return css`
      background: ${Styles.color.alert[type].background};
      color: ${Styles.color.alert[type].text};
    `;
  }}
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;

  ${Styles.desktop`
    max-width: 500px;
  `}
`;
export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: ${Styles.color.white};
`;
export const Message = styled.div``;
export const Action = styled.button`
  border: none;
  background: none;
`;
export const Close = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    outline: none;
  }
`;

export const CloseLabel = styled(IconClose)`
  height: 2rem;
  fill: ${Styles.color.white};
`;

/**
 * ToastTypeLogo
 */
export const Icon = styled.div`
  padding: 0 0.5rem;
`;

export const Success = styled(IconCircleCheck)`
  display: block;
  width: 2.375rem;
  border: 2px solid ${Styles.color.white};
  border-radius: 20px;
  fill: transparent;
`;
export const Info = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.4rem;
  width: 2.4rem;
  border: 2px solid ${Styles.color.white};
  border-radius: 20px;
  font-size: 1.5rem;
  font-weight: ${Styles.fontWeight.heavy};
`;
export const Error = styled(IconCaution)`
  height: 1.4rem;
  width: 2.1rem;
  fill: ${Styles.color.error};
`;
export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 2.4rem;
  width: 2.5rem;
  border: 2px solid ${Styles.color.white};
  border-radius: 20px;
`;
